import React, { useContext, Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBell, FaHeadset } from 'react-icons/fa';
import { IoIosAdd, IoIosArrowDown } from 'react-icons/io';

import { ComponentContext } from '../context/componentContext';
import { AuthContext } from '../context/authContext';
import { UserContext } from '../context/userContext';

import Button from '../components/helpers/Button';
import ProfileMenu from '../components/Dashboard/home/ProfileMenu';
import Support from './Layout/Support';
import PersonalDetailsModal from '../components/Profile/PersonalDetailsModal';
import NationaIDModal from '../components/Profile/NationalIDModal';
import BankDetailsModal from '../components/Profile/BankDetailsModal';
import WalletBankDetailsModal from '../components/Wallet/WalletBankDetailsModal';
import DocumentModal from '../components/Docs/DocumentModal';
import Notifications from '../components/Dashboard/Notification/NotificationMenu';

import Logo from '../images/footer-logo.png';
import MemoHamburger from '../components/Hamburger';

const Header = () => {
  const {
    handleMenuOpen,
    handleToggleAccount,
    handleToggleSupport,
    handleToggleNotification,
    toggleNotification
  } = useContext(ComponentContext);

  const { isAuthenticated, session, setSession } = useContext(AuthContext);
  const { fetchNotifications } = useContext(UserContext);

  const { firstName, lastName, photoUrl } = isAuthenticated().user;

  const [notices, setNotices] = useState([]);
  const [unReadCount, setUnReadCount] = useState(0);
  const [isViewed, setIsViewed] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;
    if (session && notices.length === 0) {
      (async () => {
        try {
          let response = await fetchNotifications();
          if (response.code === 200) {
            if (mounted) {
              setNotices(response.data.notices);
              setUnReadCount(response.data.unReadCount);
              setIsViewed(response.data.isViewed);
            }
          } else setError('Unexpected Server Error!');
        } catch (error) {
          if (error && error.status === 401) setSession(false);
          else setError('Unexpected Network Error!');
        }
      })();
    }
    return () => (mounted = false);
  }, [fetchNotifications, setSession, setError, session, notices]);

  return (
    <Fragment>
      <header className="header bg-white h-20 flex items-center text-sm shadow-lg fixed z-50 w-full">
        <div className="w-full mx-auto pr-6 md:px-20">
          <div className="flex flex-wrap justify-between items-center">
            <button
              onClick={handleMenuOpen}
              className="text-cf-300 cursor-pointer ml-2 md:ml-0 hidden md:block focus:outline-none"
            >
              <MemoHamburger width="31px" height="18px" strokeWidth="2.3" />
            </button>

            <Link to="/home" className="hidden md:block">
              <Button
                className="rounded bg-cf-200 py-3 px-4 focus:outline-none text-cf-300"
                name="Dashboard"
              />
            </Link>

            <a href="https://www.completefarmer.com" className="ml-10 md:ml-0">
              <img className="w-8 md:w-10" src={Logo} alt="Logo" />
            </a>
            <div className="flex flex-wrap items-center text-sm">
              <button className="md:hidden text-3xl text-cf-300">
                <Link to="/start-farm">
                  <IoIosAdd />
                </Link>
              </button>
              <div className="hidden md:block">
                <Link to="/start-farm">
                  <Button
                    name="Start A Farm"
                    className="flex items-center bg-cf-300 rounded shadow-cfw px-3 py-3 text-white mx-4 focus:outline-none"
                    svg={
                      <div className="text-xl">
                        <IoIosAdd />
                      </div>
                    }
                  />
                </Link>
              </div>
              <button
                onClick={handleToggleSupport}
                className="hidden md:block mx-4 text-cf-300 focus:outline-none text-xl"
              >
                <FaHeadset />
              </button>
              <button
                onClick={handleToggleNotification}
                className="flex mx-4 text-cf-300 focus:outline-none text-xl"
              >
                <FaBell />
                {!isViewed && unReadCount && (
                  <span
                    className="-ml-3 rounded-full bg-red-500 px-2 text-white text-xs font-bold relative"
                    style={{ fontFamily: 'sans-serif', top: '-1rem' }}
                  >
                    {unReadCount}
                  </span>
                )}
              </button>

              <div onClick={handleToggleAccount} className="flex items-center">
                <p className="hidden md:block mx-3 font-semibold text-gray-800 text-sm cursor-pointer">
                  Hi {firstName} {lastName}
                </p>
                <div className="flex">
                  <div className="h-6 md:h-8 w-6 md:w-8 overflow-hidden rounded-full border-2 border-gray-600 xl:border-gray-300">
                    <img
                      src={photoUrl}
                      alt={firstName}
                      className="inline-block h-full w-full object-cover"
                    />
                  </div>
                  <button className="text-gray-700 focus:outline-none text-xl">
                    <IoIosArrowDown />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <ProfileMenu />
      <Notifications toggleNotification={toggleNotification} notices={notices} />
      <Support />
      <PersonalDetailsModal />
      <NationaIDModal />
      <BankDetailsModal />
      <WalletBankDetailsModal />
      <DocumentModal />
    </Fragment>
  );
};

export default Header;
